import { useState } from "react";
import { Plus, Minus } from "lucide-react";

export const faqs = [
  { q: "Why does quality tile work cost more than a quick DIY fix?", a: "Tile is the visible 10% of a job — the other 90% is waterproofing, substrate prep, and layout planning that determines whether your install lasts 2 years or 20. We charge for the work that doesn't show, because that's the work that protects your investment." },
  { q: "What happens after I fill out the contact form?", a: "Robert personally calls or emails within 24 hours to discuss your project. From there, we'll schedule an on-site walkthrough and provide a detailed written quote — no high-pressure sales, just a clear plan." },
  { q: "Do you provide the tile, or do I source it?", a: "Either works. We have long-standing relationships with Utah's best stone yards and tile suppliers, and we're happy to guide you through selection. If you've already chosen materials, we'll work with what you have." },
  { q: "What areas in Utah do you serve?", a: "We're a service-area business covering Park City, Salt Lake County, Utah County, Davis County, Summit County, and West Jordan. If you're nearby and not on the list, just ask." },
  { q: "Do you handle commercial projects?", a: "Yes. Restaurants, retail, lobbies, and tenant improvements are all in our wheelhouse. We work directly with general contractors and design teams." },
  { q: "Can you fix a previous installer's mistakes?", a: "It's one of the most common reasons people call us. Leaking showers, cracking grout, and bad layouts are all things we diagnose and rebuild correctly." },
];

export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <section id="faq" className="py-20 md:py-28 bg-cream">
      <div className="container-prose">
        <div className="grid lg:grid-cols-[1fr_2fr] gap-12">
          <div>
            <span className="eyebrow">Common questions</span>
            <h2 className="mt-3 font-display text-3xl md:text-5xl text-foreground leading-tight">Answers before you ask.</h2>
            <p className="mt-5 text-muted-foreground leading-relaxed">Don't see your question? Call Robert directly at <a href="tel:8015982226" className="text-primary font-semibold hover:underline">(801) 598-2226</a>.</p>
          </div>
          <div className="border-t border-border">
            {faqs.map((f, i) => (
              <div key={f.q} className="border-b border-border">
                <button className="w-full flex items-center justify-between gap-6 py-6 text-left" onClick={() => setOpen(open === i ? null : i)} aria-expanded={open === i}>
                  <span className="font-display text-lg md:text-xl text-foreground">{f.q}</span>
                  {open === i ? <Minus className="h-5 w-5 text-primary flex-shrink-0" /> : <Plus className="h-5 w-5 text-primary flex-shrink-0" />}
                </button>
                {open === i && (<p className="pb-6 text-muted-foreground leading-relaxed pr-12">{f.a}</p>)}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
